import Vue from 'vue'

export default (context, inject) => {
  const isImpersonation = () => !!context.store.getters['user/isImpersonation']

  inject('isImpersonation', isImpersonation)
  context.$isImpersonation = isImpersonation

  Vue.directive('impersonation-hide', {
    bind(el) {
      if (context.store.getters['user/isImpersonation']) {
        el.style.display = 'none'
      }
    },
    inserted(el) {
      if (context.store.getters['user/isImpersonation']) {
        el.style.display = 'none'
      }
    },
  })

  Vue.directive('impersonation-disable', {
    bind(el) {
      if (context.store.getters['user/isImpersonation']) {
        el.setAttribute('disabled', 'disabled')
        el.classList.add('disabled')
        el.style.pointerEvents = 'none'
        el.style.opacity = '0.5'
      }
    },
    inserted(el) {
      if (context.store.getters['user/isImpersonation']) {
        el.setAttribute('disabled', 'disabled')
        el.classList.add('disabled')
        el.style.pointerEvents = 'none'
        el.style.opacity = '0.5'
      }
    },
  })
}
